export const homeProblemStatement = "You shouldn't have to spend hours searching and still wonder what you missed.";
export const homeProblems = [
    { problem: "You shouldn't search five portals to find one tender", solution: "With CFP, you won't!" },
    { problem: "You shouldn't guess if you're missing opportunities", solution: "With CFP, you won't!" },
    { problem: "You shouldn't write bids from scratch under pressure", solution: "With Tender Ninja, you won't!" },
]


export const shouldntWont = [
    { problem: 'You shouldn\'t search five portals to find one tender.', solution: 'With CFP, you won\'t!' },
    { problem: 'You shouldn\'t guess whether you\'re missing opportunities.', solution: 'With CFP, you won\'t!' },
    { problem: 'You shouldn\'t spend hours researching a buyer before deciding to bid.', solution: 'With CFP, you won\'t!' },
    { problem: 'You shouldn\'t write bids from scratch under deadline pressure.', solution: 'With Tender Ninja, you won\'t!' },
    { problem: 'You shouldn\'t enter a framework process without knowing who is already on it.', solution: 'With CFP, you won\'t!' },
]

export const analyticsProblemStatement = "You shouldn't be writing bids without understanding the market and still wondering why you're losing.";
export const analyticsProblems = [
    {
        problem: "You shouldn't guess which sectors or regions offer the best growth opportunities",
        solution: "With CFP Analytics, you'll know!",
    },
    {
        problem: "You shouldn't go into a bid without knowing the buyer's procurement history",
        solution: "With CFP Analytics, you'll know!",
    },
    {
        problem: "You shouldn't write competitive proposals without knowing who you're up against",
        solution: "With CFP Analytics, you will!",
    },
]


export const coreProblemStatement = "You shouldn't have to spend hours searching and still wonder what you missed";
export const coreProblems =
    [
        { problem: "You shouldn't search five portals to find one tender", solution: "With CFP Core, you won't!" },
        { problem: "You shouldn't guess if you're missing opportunities", solution: "With CFP Core, you won't!" },
        { problem: "You shouldn't go into a bid not knowing who you're up against", solution: "With CFP Core, you won't!" },
    ]


export const ninjaProblemStatement = "You shouldn't have to write every bid from scratch, you should build on previous bids";
export const ninjaProblems = [
    {
        problem: "You shouldn't spend days getting to a first draft",
        solution: "With Tender Ninja, you won't!",
    },
    {
        problem: "You shouldn't submit a response you can't trace back to real evidence",
        solution: "With Tender Ninja, you won't!",
    },
    {
        problem: "You shouldn't score poorly by providing low quality answers",
        solution: "With Tender Ninja, you won't!",
    },
]